import { httpRetry } from '$core/helpers/http-retry';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { PostalDeliveryDataDto } from '../types';
import { StaticStorage } from '../static-storage';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PostalDeliveryService {
  private readonly http = inject(HttpClient);
  private readonly staticStorage = inject(StaticStorage);

  public getPostalDeliveryStatics(): Observable<unknown> {
    return this.http.get<unknown>('/v2/postal-delivery-data').pipe(
      httpRetry(5),
      tap((res: PostalDeliveryDataDto) => {
        this.staticStorage.updateStatic(res);
      })
    );
  }
}
